import request from "@/utils/request";
//查询所有启用的仓库
export function selectWareByEnable() {
  return request({
    url: "inventory/warehouse/selectByEnable",
    method: "get"
  });
}
// 查询七天各类别入库数量
export function sevenDaysExpendQuantity(query) {
  return request({
    url: "inventory/report/sevenDaysExpendQuantity",
    method: "get",
    params: query
  });
}
// 入库单
export function selectExpendTwohundred(query) {
  return request({
    url: "inventory/report/selectExpendTwohundred",
    method: "get",
    params: query
  });
}
// 入库类别
export function countByCategory(whId) {
  return request({
    url: "inventory/workbench/countByCategory",
    method: "get",
    params: { whId }
  });
}
// 入库类别有时间
export function countByCategorytime(query) {
  return request({
    url: "inventory/workbench/countByCategory",
    method: "get",
    params: query
  });
}
export function selectEnterRank(query) {
  return request({
    url: "inventory/report/selectEnterRank",
    method: "get",
    params: query
  });
}
